module.exports = require("./ar-YE.js");